





































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { ssmHttpService } from "@/shared/services/http-service";
import messageModule from "@/store/modules/message-module";

// DevExtreme Imports
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxPager,
  DxFilterRow,
  DxHeaderFilter,
} from "devextreme-vue/data-grid";
import { API } from "@/shared/api";
import ThreatExplorer from "./ThreatExplorer.vue";
import ThreatGeoDashboard from "./ThreatGeoDashboard.vue";

@Component({
  name: "IpRateLimiting",
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxPager,
    DxFilterRow,
    DxHeaderFilter,
    ThreatExplorer,
    ThreatGeoDashboard,
  },
})
export default class IpRateLimiting extends Vue {
  public tab: number = 0;
  public loadingActive: boolean = false;
  public loadingHistory: boolean = false;
  public loadingConfig: boolean = false;
  public savingConfig: boolean = false;
  public unbanningIp: string | null = null;
  public banningInProgress: boolean = false;

  public config: any = {
    id: 0,
    active: true,
    max_requests: 20,
    time_window_seconds: 30,
    enable_path_probing: true,
    enable_waf_filter: true,
    enable_rate_limiting: true,
    enable_privilege_probing: true,
    enable_honeypot: true,
    enable_uba_analytics: true,
  };

  // Dialogo de baneo
  public banDialog: boolean = false;
  public banFormValid: boolean = false;
  public dateMenu: boolean = false;
  public banConfig: any = {
    ip: "",
    reason: "",
    expirationType: "7d",
    expiryDate: new Date().toISOString().substr(0, 10),
  };

  public expirationOptions: any[] = [
    { text: "7 Días", value: "7d" },
    { text: "30 Días", value: "30d" },
    { text: "Permanente", value: "forever" },
    { text: "Fecha Personalizada", value: "custom" },
  ];

  public activeBans: any[] = [];
  public history: any[] = [];
  public rankingThreats: any[] = [];

  get todayDate() {
    return new Date().toISOString().substr(0, 10);
  }

  public mounted() {
    this.loadActiveBans();
    this.loadHistory();
    this.loadConfig();
    this.loadRanking();
  }

  public async loadRanking() {
    try {
      this.rankingThreats = await ssmHttpService.get(
        API.threatIntelligence + "/ranking?limit=50"
      );
    } catch (error) {
      console.error("Error loading ranking for dashboard:", error);
    }
  }

  public handleBanRequest(ip: string) {
    this.banConfig = {
      ip: ip,
      reason: "Baneo proactivo desde Threat Intelligence (UBA)",
      expirationType: "7d",
      expiryDate: this.todayDate,
    };
    this.banDialog = true;
  }

  public async loadActiveBans() {
    this.loadingActive = true;
    try {
      this.activeBans = await ssmHttpService.get(
        API.IpRateLimiting + "/active-bans"
      );
    } catch (error) {
      console.error("Error loading active bans:", error);
    } finally {
      this.loadingActive = false;
    }
  }

  public async loadHistory() {
    this.loadingHistory = true;
    try {
      this.history = await ssmHttpService.get(
        API.IpRateLimiting + "/history?limit=200"
      );
    } catch (error) {
      console.error("Error loading history:", error);
    } finally {
      this.loadingHistory = false;
    }
  }

  public async loadConfig() {
    this.loadingConfig = true;
    try {
      const data = await ssmHttpService.get(API.IpRateLimiting + "/config");
      if (data) {
        this.config = data;
      }
    } catch (error) {
      console.error("Error loading config:", error);
    } finally {
      this.loadingConfig = false;
    }
  }

  public async saveConfig() {
    this.savingConfig = true;
    try {
      await ssmHttpService.post(API.IpRateLimiting + "/config", this.config);
      messageModule.showToast({
        text: "La configuración se ha actualizado correctamente.",
        type: "success",
      });
    } catch (err) {
      const error = err as any;
      let msg = "No se pudo guardar la configuración.";
      if (error && error.response && error.response.data) {
        msg = error.response.data;
      }
      messageModule.showAlert({ title: "Error", text: msg, type: "error" });
    } finally {
      this.savingConfig = false;
    }
  }

  public unbanIp(ip: string) {
    messageModule.showConfirm({
      title: "¿Desbloquear IP?",
      text: `Se permitirá el acceso de nuevo a la IP ${ip}.`,
      cb: async (confirmed: boolean) => {
        if (!confirmed) return;
        this.unbanningIp = ip;
        try {
          await ssmHttpService.post(API.IpRateLimiting + "/unban", ip);
          messageModule.showToast({
            text: "La IP ha sido desbloqueada correctamente.",
            type: "success",
          });
          this.loadActiveBans();
        } catch (err) {
          const error = err as any;
          let msg = "No se pudo desbloquear la IP.";
          if (error && error.response && error.response.data) {
            msg = error.response.data;
          }
          messageModule.showAlert({ title: "Error", text: msg, type: "error" });
        } finally {
          this.unbanningIp = null;
        }
      },
    });
  }

  public async openBanDialog() {
    this.banConfig = {
      ip: "",
      reason: "",
      expirationType: "7d",
      expiryDate: this.todayDate,
    };
    this.banDialog = true;
  }

  public async submitBan() {
    this.banningInProgress = true;
    try {
      let finalExpiry = this.banConfig.expiryDate;
      if (this.banConfig.expirationType === "7d") {
        const d = new Date();
        d.setDate(d.getDate() + 7);
        finalExpiry = d.toISOString();
      } else if (this.banConfig.expirationType === "30d") {
        const d = new Date();
        d.setDate(d.getDate() + 30);
        finalExpiry = d.toISOString();
      } else if (this.banConfig.expirationType === "forever") {
        finalExpiry = "9999-12-31T23:59:59";
      }

      await ssmHttpService.post(API.IpRateLimiting + "/ban", {
        ip: this.banConfig.ip,
        reason: this.banConfig.reason,
        expiry: finalExpiry,
      });

      messageModule.showToast({
        text: "La IP ha sido bloqueada correctamente.",
        type: "success",
      });
      this.banDialog = false;
      this.loadActiveBans();
    } catch (err) {
      const error = err as any;
      let msg = "No se pudo bloquear la IP.";
      if (error && error.response && error.response.data) {
        msg = error.response.data;
      }
      messageModule.showAlert({ title: "Error", text: msg, type: "error" });
    } finally {
      this.banningInProgress = false;
    }
  }

  public getViolationColor(type: string) {
    if (!type) return "grey";
    const t = type.toLowerCase();
    if (t.includes("honeypot")) return "red darken-4";
    if (t.includes("login") || t.includes("auth")) return "orange darken-2";
    if (t.includes("scan") || t.includes("route")) return "deep-purple";
    if (t.includes("/api/")) return "blue-grey";
    return "blue-grey";
  }

  public getViolationText(path: string) {
    if (!path) return "Actividad Desconocida";
    if (path.includes("Honeypot")) return "BOT / HONEYPOT";
    if (path.includes("Failed Login")) return "INTENTO LOGIN FALLIDO";
    if (path.startsWith("/api/")) return "ACCESO API";
    return path;
  }

  public get securityPosture() {
    if (!this.config.active) {
      return {
        level: "DESACTIVADA",
        color: "error",
        icon: "mdi-shield-off-outline",
        description:
          "El sistema de seguridad está apagado. El servidor es vulnerable a cualquier tipo de ataque automatizado.",
      };
    }

    const modules = [
      this.config.enable_rate_limiting,
      this.config.enable_honeypot,
      this.config.enable_waf_filter,
      this.config.enable_path_probing,
      this.config.enable_privilege_probing,
    ];

    const activeCount = modules.filter((m) => m).length;

    if (activeCount >= 5) {
      return {
        level: "MÁXIMA",
        color: "success",
        icon: "mdi-shield-check",
        description:
          "Protección multicapa completa activa. El sistema está blindado contra bots, inyecciones y ataques de fuerza bruta.",
      };
    } else if (activeCount >= 3) {
      return {
        level: "REFORZADA",
        color: "primary",
        icon: "mdi-shield-sync",
        description:
          "Postura de seguridad sólida. Los vectores de ataque más comunes están cubiertos satisfactoriamente.",
      };
    } else {
      return {
        level: "BÁSICA",
        color: "orange",
        icon: "mdi-shield-alert-outline",
        description:
          "Protección mínima activa. Se recomienda habilitar más módulos para una defensa eficaz.",
      };
    }
  }
}
